import React from "react"
import { withRouter } from "react-router-dom"
import { view } from "react-easy-state"
import { Row, Col, Tooltip, Progress, Avatar, Button, Empty } from "antd"

import CourseSubscriptionsService from "services/students/course_subscriptions.service"

const CourseList = (props) => {
  const { courses, course_invitations = [], subscribable, title } = props

  console.log("CourseList: courses:", JSON.parse(JSON.stringify(courses)))

  if (!courses || courses.length === 0) {
    return (
      <div className="course-list no-course">
        <Empty description="You have not subscribed any course yet.">
          <Button type="primary" onClick={() => props.history.push(`/courses`)}>
            View all courses
          </Button>
        </Empty>
      </div>
    )
  }

  const courseColSpans = {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 6 },
  }

  const handleCourseCardClick = (courseId) => {
    if (subscribable) return
    props.history.push(`/courses/${courseId}/subjects`)
  }

  const handleSubscribe = async (courseId) => {
    if (!subscribable) return
    const pageState = {}
    // props.history.push(`/courses/${courseId}/payment`)
    await CourseSubscriptionsService.create({ pageState, courseId })
    console.log("CourseList: handleSubmit: pageState:", pageState)
    if (pageState.courseSubscriptionCreateError) return
    // TODO: simulate a page refresh here instead of pushing a hardcoded route
    props.refresh()
  }

  return (
    <div className="course-list" style={props.style}>
      {title && <h3>{title}</h3>}
      <Row gutter={20} type="flex">
        {courses.map((course) => {
          const course_invitation = course_invitations.find((ci) => ci.course_id === course.id)
          const courseSubscribable = subscribable && !!course_invitation

          return (
            <Col key={course.id} {...courseColSpans} className="m-t-20">
              <div className="course-item-card" onClick={() => handleCourseCardClick(course.id)}>
                <div className="course-image">
                  <img src={course.image_url} alt={course.name} />
                </div>
                <div className="course-info">
                  {courseSubscribable && (
                    <Button
                      type="primary"
                      size="large"
                      block
                      onClick={() => handleSubscribe(course.id)}
                      style={{ marginBottom: 10 }}
                    >
                      Subscribe
                    </Button>
                  )}
                  <Tooltip placement="top" title={course.name} arrowPointAtCenter>
                    <div className="course-title">{course.name}</div>
                  </Tooltip>
                  {courseSubscribable && course.features && (
                    <div className="course-features">
                      <h3>Features</h3>
                      <ul>
                        {Array.isArray(course.features) &&
                          course.features.map((f, index) =>
                            f.value ? (
                              <li key={index}>
                                <strong>{f.value}</strong> {f.label}
                              </li>
                            ) : null,
                          )}
                      </ul>
                    </div>
                  )}
                  {false && (
                    <Progress
                      strokeColor={{
                        "0%": "#108ee9",
                        "100%": "#87d068",
                      }}
                      percent={course.userProgress || 0}
                      strokeWidth={12}
                      showInfo={false}
                      style={{ margin: "15px 0px" }}
                    />
                  )}

                  {false && (
                    <div className="course-states">
                      <div className="course-auther">
                        <Avatar src={`https://i.pravatar.cc/150?u=${course.id}`} />{" "}
                        <span>{course.instructor && course.instructor[0] && course.instructor[0].name}</span>
                      </div>
                      <div className="course-completed">
                        <strong>{course.userProgress || 0}%</strong>
                        <span> Completed</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          )
        })}
      </Row>
    </div>
  )
}

export default withRouter(view(CourseList))
